webpackJsonp([169858455373905],{

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Paper = __webpack_require__(22);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _styles = __webpack_require__(16);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(84);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logoAutoclub = __webpack_require__(128);
	
	var _logoAutoclub2 = _interopRequireDefault(_logoAutoclub);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _favicon = __webpack_require__(41);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _container;
	
	  return {
	    container: (_container = {
	      width: '70%'
	    }, _container[theme.breakpoints.down('lg')] = {
	      width: '75%'
	    }, _container[theme.breakpoints.down('md')] = {
	      width: '88%'
	    }, _container[theme.breakpoints.down('sm')] = {
	      width: '95%'
	    }, _container.margin = '0 auto', _container.padding = '40px 0', _container),
	    coloredBandana: {
	      backgroundColor: theme.palette.primary.main,
	      height: 20
	    },
	    colorDark: {
	      color: theme.palette.primary.main
	    },
	    textFieldShort: {
	      width: '47%'
	    }
	  };
	};
	
	var WhoWeAre = function (_React$Component) {
	  _inherits(WhoWeAre, _React$Component);
	
	  function WhoWeAre() {
	    _classCallCheck(this, WhoWeAre);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WhoWeAre.prototype.render = function render() {
	    var posts = (0, _get2.default)(this, 'props.data.allMarkdownRemark.edges');
	    var classes = this.props.classes;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: classes.container },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Who we are'
	        ),
	        _react2.default.createElement('link', { rel: 'icon', type: 'favicon', href: _favicon2.default, sizes: '16x16' })
	      ),
	      _react2.default.createElement('div', { className: classes.coloredBandana }),
	      _react2.default.createElement(
	        _Paper2.default,
	        { style: { marginBottom: 55, padding: '20px 30px' } },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              alignItems: 'center'
	            }
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            _react2.default.createElement('img', { src: _logoAutoclub2.default, width: 64, height: 37 })
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: classes.colorDark, style: { marginLeft: 20 } },
	            'AUTO CLUB REVIEWS - WHO WE ARE'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: classes.colorDark },
	          'Auto Club Reviews is an experienced team that has worked with the very best independent car service companies, dedicated to delivering the best possible tools, accesories and automotive advice, all around the world.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: classes.colorDark },
	          'We look forward to advising you to make your entire automobile experience an exceptional one.'
	        )
	      )
	    );
	  };
	
	  return WhoWeAre;
	}(_react2.default.Component);
	
	WhoWeAre.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _styles.withStyles)(styles)(WhoWeAre);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-who-we-are-js-c1d2ecfb61a34f31571d.js